export default __webpack_public_path__ + "static/media/node.1beb6424.png";